import React, { Component } from "react";
import {
  getTabForms,
  updateTab,
  getTabs,
  removeTab,
} from "../../../services/formService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../../config';
import { logActivity } from '../../../services/utilService';

class WTab extends Component {
  form_options = [];
 

  constructor(props) {
    super(props);

  
    this.state = {
      Tabs: [{ Tab_ID: -1, Tab_Name: "", Tab_Form_ID: "" }],
      loading: true
      // Widget information in props.Widget
    };
  
  }

  async componentDidMount() {
    const {Project_ID} = this.props;
    this.setState({ loading: true });
    const { data: forms } = await getTabForms(Project_ID);
  
    this.form_options = forms.filter((f) => f.Form_ID !== this.props.Form_ID);

    const { data: Tabs } = await getTabs(this.props.Widget.Widget_ID);
    this.setState({ Tabs });
    this.setState({ loading: false });
  }

  handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const Tabs = [...this.state.Tabs];
    Tabs[index][name] = value;
    this.setState({ Tabs });
  };

  handleSingleRemove = async (index) => {
    const tab = this.state.Tabs[index];

    const { data } = await removeTab(this.props.Widget.Widget_ID, tab.Tab_ID);
    if (data.includes("Success")) {
      const Tabs = [...this.state.Tabs];
      Tabs.splice(index, 1);
      this.setState({ Tabs });
      toaster('success', 'Tab removed');
      logActivity('/formBuilder','WIDGET_TAB_DELETE_SUCCESS');
    } else {
      toaster('error', data);
      logActivity('/formBuilder','WIDGET_TAB_DELETE_FAILED');
    }
  };

  handleAdd = () => {
    const idx = -(this.state.Tabs.length + 1);
    const Tabs = [
      ...this.state.Tabs,
      { Tab_ID: idx, Tab_Name: "", Tab_Form_ID: "" },
    ];
    this.setState({ Tabs });
  };

  handleSave =async ()=> {
    const { Widget_ID } = this.props.Widget;
    const { data } = await updateTab(Widget_ID, this.state.Tabs);
    toaster('success', data);
    logActivity('/formBuilder','WIDGET_TAB_SAVE_SUCCESS');
  }

  handleRemove =() =>{
    this.props.onRemove(this.props.Widget.Widget_ID);
  }

  render() {
    let { Tabs } = this.state;
    return (
      <React.Fragment>
        <div className="text-center">
          {Tabs.map((row, idx) => {
            return (
              <div className="form-row" key={idx}>
                <div className="form-group col-md-5">
                  <input
                    className="form-control"
                    name="Tab_Name"
                    placeholder="Enter Tab Name"
                    value={row.Tab_Name}
                    onChange={(e) => this.handleInputChange(e, idx)}
                  />
                </div>

                <div className="form-group col-md-6">
                  <select
                    className="custom-select"
                    value={row.Tab_Form_ID}
                    name="Tab_Form_ID"
                    onChange={(e) => this.handleInputChange(e, idx)}
                  >
                    <option>Select Form</option>
                    {this.form_options.map((form) => {
                      return (
                        <option key={form.Form_ID} value={form.Form_ID}>
                          {form.Form_Name}
                        </option>
                      );
                    })}
                  </select>
                </div>

                {Tabs.length !== 1 && (
                  <div className="form-group col-md-1">
                    <button
                      className="btn btn-outline-warning btn-sm"
                      onClick={() => this.handleSingleRemove(idx)}
                    >
                      Remove
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
        <br />
        <div className="text-center">
          <button
            className="btn btn-outline-success btn-sm"
            onClick={this.handleAdd}
          >
            <FontAwesomeIcon icon={faPlus} />
          </button>
        </div>

        <div className="float-right">
          <button
            className="btn btn-outline-primary m-2"
            onClick={this.handleSave}
          >
            Save
          </button>
          <button
            className="btn btn-outline-danger"
            onClick={this.handleRemove}
          >
            Delete
          </button>
        </div>
        <ToastContainer/>
      </React.Fragment>
    );
  }
}

export default WTab;
